import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { ID } from 'types/common';
import { Merchant } from 'types/user';

interface RequestMoney {
    requestMoneyId: number;
    username: string;
    firstName: string;
    lastName: string;
    amount: number;
    createdDate: string;
    statusDate: string;
    status: string;
    myRole: string;
    subject: string;
    currencyCode: string;
    imgUrl: string;
    sentTo: string;
    sentFrom: string;
    companySender?: Merchant;
}
const requestMoneyInitialValues: RequestMoney = {
    requestMoneyId: 0,
    username: '',
    firstName: '',
    lastName: '',
    amount: 0,
    createdDate: '',
    statusDate: '',
    status: '',
    myRole: '',
    subject: '',
    currencyCode: '',
    sentTo: '',
    sentFrom: '',
    imgUrl: '',
    companySender: undefined,
};
interface WalletInvoiceDetail {
    requestMoney: RequestMoney;
    loading: boolean;
    error: null | boolean;
}

const initialState: WalletInvoiceDetail = {
    requestMoney: requestMoneyInitialValues,
    loading: false,
    error: null,
};

export const updateWalletInvoiceStatus = async (requestId: string, svaId: string, newStatus: string) => {
    try {
        const payload = { requestId, svaId, newStatus };
        const res: any = await client.post('/request/updateStatus', payload);
        return res;
    } catch (e) {
        console.log('$$$ ~ updateWalletInvoiceStatus ~ e:', e);
    }
};

export const fetchWalletInvoiceDetail = createAsyncThunkWrapper<any, ID>(
    'walletInvoiceDetail/fetchWalletInvoiceDetail',
    async (requestMOneyId: ID) => {
        const response: any = await client.get(`/request/${requestMOneyId}`);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { code, msg, statusCode, ...requestMoneyDetails } = response || {};
        return requestMoneyDetails;
    }
);

const walletInvoiceDetailSlice = createSlice({
    name: 'walletInvoiceDetail',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchWalletInvoiceDetail.pending, (state) => {
            state.loading = true;
            state.error = false;
        });
        builder.addCase(fetchWalletInvoiceDetail.fulfilled, (state, action) => {
            state.loading = false;
            if (!action.payload) return;
            state.requestMoney = action?.payload || null;
        });
        builder.addCase(fetchWalletInvoiceDetail.rejected, (state) => {
            state.loading = false;
            state.error = true;
        });
    },
});

export default walletInvoiceDetailSlice.reducer;
